import React, { useEffect } from 'react';
import { AppContext } from '../../App';
import { handleCanonicalUrl, useHandleSeoSettings } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import MenuTournamentItem from '../menu/MenuTournamentItem';
import { PrematchContext } from '../Prematch';
import TournamentMenuNavbar from './TournamentMenuNavbar';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import { getConfiguration } from '../../data/utils/configuration';
import { handleHistory } from '../../data/sport-utils';


function TournamentMenu(props) {
    const conf = getConfiguration();
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const seoContext = React.useContext(SeoContext);
    //const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,true,conf.seo);

    //useHandleSeoSettings(seoSettingsState);

    const sport = prematchContext.data.sportById[props.category.sportRef];
    const sportSc = props.category.sportScRef && prematchContext.data.sportById[props.category.sportScRef];
    //const absoluteSportPath = useAbsolutePath([sport.urlPath, sport.urlPathSuffix].join(''));
    const categoryPath = [props.category.urlPath, props.category.urlPathSuffix].join('');
    const absoluteCategoryPath = useAbsolutePath(categoryPath,null,props.category.urlPathSeo);

    useEffect(() => {
        if(!window.appConfig.SHOP_MODE){
            if(window.history){
                seoContext.refreshPathname(categoryPath,appContext.location.current);
                handleCanonicalUrl(absoluteCategoryPath);
                //window.history.replaceState(window.history.state, null, absoluteCategoryPath);
            }
            return () =>{
                //appContext.location.current === 'prematch' && window.history.replaceState(window.history.state, null, absoluteCategoryPath.substring(0,absoluteCategoryPath.indexOf(props.category.urlPath)));
            }
        }
    }, [props.category.urlPath]);

    const items = prematchContext.applyTemporalFilter(props.category.tournaments).map(function(t) {
        function handleClick() {
            prematchContext.openTournament(t.uniqueId);
        }
        return (
            <MenuTournamentItem key={t.id}
                                id={t.id}
                                desc={t.descrizione}
                                info={t.tournamentsCount}
                                sportRef={t.sportRef}
                                categoryRef={t.categoryRef}
                                isLive={t.isLive}
                                action={handleClick}
                                href={[t.urlPath, t.urlPathSuffix].join('')} 
                                urlPathSeo={t.urlPathSeo}
                                urlPathSeoSettings={t.urlPathSeoSettings} />
        );
    });

    return (
        <>  
            <SeoMetaTags />
            <TournamentMenuNavbar sport={sport} category={props.category} sportSc={sportSc}/>
            <div className="menu-container">
                {items}
                <SeoMainContainer />
            </div>
        </>
    );
}

export default TournamentMenu;